(ns app.bundle-social-instagram.platform
  "Instagram professional accounts through bundle.social: Stories and
   Reels over Instagram's official API.

   A hidden platform (see `app.bundle-social.platforms/hidden-platforms`):
   no page offers it as a destination. It is the fallback connection of
   an Instagram account that Storrito posts on with its own integration:
   when that account is disconnected, its due stories and reels are
   handed off to this connection.

   Only data and pure functions, see `app.bundle-social.platforms` for
   the keys. The official API publishes a Story as plain media: the
   stickers are baked into the rendered video or image, but they are not
   interactive."
  (:require [app.bundle-social.text :as text]
            [app.subscription.services :as services]
            [ui.icons :as icons]))

(defn post-data
  "The `data.INSTAGRAM` entry of a bundle.social post. A Story carries
   no text. A Reel carries the choices of Storrito's own reels
   (`:reel/recommend-feed`, `:reel/ai-generated?`) as the options
   `:share-to-feed` and `:ai-generated`, and the story's preview image
   as its cover (`thumbnail`)."
  [{:keys [post-type text options upload-id cover-url]}]
  (let [reel? (= "REEL" post-type)]
    (cond-> {:type post-type
             :uploadIds [upload-id]}
      (and (not= "STORY" post-type)
           (seq text))
      (assoc :text text)

      ;; Always sent: `false` unless chosen, like Storrito's own reels
      ;; (`:reel/recommend-feed`), although Meta's default is `true`.
      ;; The checkbox option drops an unticked value, so omitting the
      ;; field would put every reel on the feed. The handoff copies
      ;; `:reel/recommend-feed` into `:share-to-feed`.
      reel?
      (assoc :shareToFeed (true? (:share-to-feed options))
             :isAiGenerated (true? (:ai-generated options)))

      (and reel? cover-url)
      (assoc :thumbnail cover-url))))

(def platform
  {:social-platform/id "INSTAGRAM"
   ;; Not `:instagram`, which is the kind of Storrito's own Instagram
   ;; integration in the account selector and the agenda.
   :social-platform/key :bundle-instagram
   :social-platform/name "Instagram"
   :social-platform/account-noun "Instagram account"
   :social-platform/icon icons/instagram-logo
   :social-platform/text-class ["text-pink-600"]
   :social-platform/pill-class ["bg-pink-50" "border-pink-200" "text-pink-700"]
   :social-platform/launched? false
   ;; Instagram's own OAuth instead of Facebook Login: the account is
   ;; chosen during the OAuth, no Facebook page is needed.
   :social-platform/connect-options {:instagramConnectionMethod "INSTAGRAM"}
   ;; Connected per Instagram account on the Instagram Accounts page
   ;; (`ui.instagram-connect.page`), the only entry point.
   :social-platform/accounts-page-label "Instagram Accounts"
   :social-platform/return-path "/ui/instagram-connect"
   ;; Matched to the account of Storrito's own integration by username
   ;; (`app.bundle-social-instagram.accounts`).
   :social-platform/username-as-name? true
   ;; The invoice tells the fallback's posts from the regular ones.
   :social-platform/line-item-name "Instagram fallback"
   ;; Decided with Tobias on 2026-10-07: the hint names the price and
   ;; that the stickers are not interactive. Never name the provider.
   ;; No card: only the hint modal's button reads its style.
   :social-platform/connect-card
   {:style {:button-class ["bg-pink-600" "text-white" "hover:bg-pink-700"]}}
   :social-platform/connect-hint
   ;; Short, the key words bold: read at a glance.
   {:title "Add a fallback connection"
    :body [:span "If the regular connection drops, your stories and reels "
           [:strong "still go out on time"]
           ", through Instagram's official API."]
    :points [[:span [:strong "Backup only:"] " used only while the regular connection is down."]
             ;; The price `app.bundle-social.billing` charges.
             [:span [:strong (str (text/format-credits (:social-post (services/get-service->prices {})))
                                  " credits")]
              " per post through the fallback."]
             [:span [:strong "Stickers"] " are shown, but " [:strong "not clickable"] "."]
             ;; Instagram's official API publishes stories only for
             ;; business accounts, reels also for creator accounts.
             [:span "Needs a " [:strong "Business account"] ". Creator accounts: " [:strong "reels only"] "."]]
    ;; The type of the account, see
    ;; `app.bundle-social-instagram.account-type`.
    :account-type-notes
    {:creator [:span [:strong "Creator account: reels only."]
               " Switch to Business in the Instagram app to cover stories. Updates after the next sync."]
     :personal [:span [:strong "Personal account: not supported."]
                " Switch to Business in the Instagram app first. Updates after the next sync."]}}
   :social-platform/post-data post-data
   ;; Storrito's videos are at most 60 s long; bundle.social limits
   ;; captions to 2000 characters.
   :social-platform/post-types
   [{:post-type/id "STORY"
     :post-type/kind :bundle-instagram-story
     :post-type/label "Instagram Story"
     :post-type/group-label "Instagram Stories"
     :post-type/mark "Story"
     :post-type/media #{:video :image}
     :post-type/max-duration-seconds 60
     :post-type/caption? false}
    {:post-type/id "REEL"
     :post-type/kind :bundle-instagram-reel
     :post-type/label "Instagram Reel"
     :post-type/group-label "Instagram Reels"
     :post-type/mark "Reel"
     :post-type/media #{:video}
     :post-type/caption? true
     :post-type/max-text-length 2000
     :post-type/cover? true
     ;; No page asks for them: the handoff copies them from the reel.
     :post-type/options
     [{:option/key :share-to-feed
       :option/type :checkbox
       :option/label "Also share to feed"}
      {:option/key :ai-generated
       :option/type :checkbox
       :option/label "AI-generated content"}]}]})
